import _get from 'lodash/get';

import { Google, GoogleTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;
/**
 * @summary Sends Pixall, Adobe and Google impressions for the safety recall card
 */
export function inventoryRecallImpression(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
    } = metadata;

    const { inventoryId } = data;
    const pageName = _get(dataLayer, 'page.pageName', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);
    const eventData = {
        vehicle: { ...vehicleData },
    };

    const element = `vdp_${data?.listingType.toLowerCase()}`;
    const cmp = 'cta::safety-recall';

    Google.sendImpressions(metadata, {
        eventElement: element,
        eventResult: cmp,
        eventData,
    }, option);

    return { cmp, element };
}
